import Preloader from 'components/Preloader';
import { useTranslation } from 'react-i18next';
import { FormProvider } from 'react-hook-form';
import CustomTextInput from 'components/Forms/CustomTextInput';
import { Box, Grid, Typography, IconButton, Button } from '@mui/material';
import useInventory from 'components/MenuNew/hooks/useInventoryHook';
import {
  Add as AddIcon,
  Remove as RemoveIcon,
  Edit as EditIcon,
} from '@mui/icons-material';
import CreateInventoryDialog from 'components/MenuNew/FormView/Inventory/CreateInventoryDialog';

const ProductFormInventory = ({ productFormMethods }) => {
  const { t } = useTranslation();
  const {
    handleSubmit,
    inventoryFields,
    inventoryMethods,
    open,
    handleClose,
    handleOpen,
    replaceInventory,
    deleteInventory,
    handleEdit,
    editingItem,
    isLoading,
    isDisabled,
  } = useInventory(productFormMethods);

  if (isLoading) {
    return <Preloader loading={isLoading} />;
  }

  if (
    inventoryFields?.length > 0 &&
    !inventoryFields[0]?.name &&
    !inventoryFields[0]?.uuid &&
    !isLoading
  ) {
    return (
      <Box sx={{ p: 3, textAlign: 'center' }}>
        <Typography>{t('No Components Items Available')}</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      <CreateInventoryDialog
        open={open}
        onClose={handleClose}
        onSave={() => {}}
        title="Create Inventory to Product"
        productId={productFormMethods.getValues()?._id}
        replaceInventory={replaceInventory}
        productInventory={productFormMethods.getValues('inventory')}
        editingItem={editingItem}
        productFormMethods={productFormMethods}
        currentData={inventoryFields}
      />
      <FormProvider {...inventoryMethods}>
        <form onSubmit={inventoryMethods.handleSubmit(handleSubmit)} noValidate>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom>
                {t('Components Items')}
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Specify the individual SKU items and quantities that make up
                this product (if applicable)
              </Typography>
            </Grid>

            {inventoryFields?.length > 0 &&
              inventoryFields?.map((field, index) => {
                if (field?.isMain) return null;
                return (
                  <Grid item xs={12} key={field.id} sx={{ mb: 2 }}>
                    <Box
                      sx={{
                        display: 'flex',
                        gap: 2,
                        width: '100%',
                        alignItems: 'center',
                      }}
                    >
                      <CustomTextInput
                        sx={{ flex: 1 }}
                        label={t('Inventory Item')}
                        name={`inventoryItems[${index}].name`}
                        disabled={true}
                      />
                      <CustomTextInput
                        sx={{ flex: 1 }}
                        label={t('Qty')}
                        name={`inventoryItems[${index}].qty`}
                        disabled={true}
                      />
                      <IconButton
                        type="button"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          handleOpen();
                        }}
                        disabled={isDisabled}
                        color="primary"
                        size="small"
                        sx={{ ml: 1 }}
                      >
                        <AddIcon />
                      </IconButton>
                      <IconButton
                        type="button"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          handleEdit(field);
                        }}
                        disabled={
                          inventoryFields?.length === 0 ||
                          field?.isMain ||
                          isDisabled
                        }
                        color="primary"
                        size="small"
                      >
                        <EditIcon />
                      </IconButton>
                      <IconButton
                        type="button"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          deleteInventory(field?.uuid, index);
                        }}
                        disabled={
                          inventoryFields?.length === 0 ||
                          field?.isMain ||
                          isDisabled
                        }
                        color="error"
                        size="small"
                      >
                        <RemoveIcon />
                      </IconButton>
                    </Box>
                  </Grid>
                );
              })}
            {inventoryFields?.length === 1 && inventoryFields[0]?.isMain && (
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<AddIcon />}
                  disabled={isDisabled}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    handleOpen();
                  }}
                >
                  {t('Add Component Item')}
                </Button>
              </Grid>
            )}
          </Grid>
        </form>
      </FormProvider>
    </Box>
  );
};

export default ProductFormInventory;
